// tippi/src/pages/carrier/CarrierOverview.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { useOrgVehicles } from '../../hooks/useOrgVehicles';
import { useCarrierMembers } from '../../hooks/useCarrierMembers';
import { inspectionStatus, serviceStatus } from '../../utils/vehicleStatus';
import LeaveOrgCard from './LeaveOrgCard';
import { ui, chip } from './carrierStyles';

export default function CarrierOverview() {
  const { orgId, org } = useCarrierOrg();
  const { vehicles } = useOrgVehicles(orgId);
  const { members } = useCarrierMembers(orgId);

  const drivers = members.filter(m => m.role === 'driver' && m.status === 'active');
  const away = vehicles.filter(v => v.status === 'out_of_service');
  const attention = vehicles
    .map(v => ({ v, insp: inspectionStatus(v) }))
    .filter(x => x.insp.tone === 'expired' || x.insp.tone === 'soon');
  const serviceDue = vehicles
    .map(v => ({ v, svc: serviceStatus(v) }))
    .filter(x => x.svc.tone === 'expired' || x.svc.tone === 'soon');

  return (
    <>
      <h1 style={ui.h1}>{org?.orgName ?? 'Transportør'}</h1>
      <div style={ui.grid}>
        <div style={ui.stat}><div style={ui.statNumber}>{vehicles.length}</div><div style={ui.hint}>Biler</div></div>
        <div style={ui.stat}><div style={ui.statNumber}>{drivers.length}</div><div style={ui.hint}>Sjåfører</div></div>
        <div style={ui.stat}><div style={ui.statNumber}>{away.length}</div><div style={ui.hint}>Ute av drift</div></div>
        <div style={ui.stat}><div style={ui.statNumber}>{attention.length}</div><div style={ui.hint}>EU-kontroll krever oppmerksomhet</div></div>
      </div>

      <div style={ui.card}>
        <h2 style={ui.h2}>EU-kontroll som nærmer seg eller har utløpt</h2>
        {attention.length === 0 && <p style={ui.hint}>Ingen biler trenger EU-kontroll de neste 30 dagene.</p>}
        {attention.map(({ v, insp }) => (
          <Link key={v.id} to={`/transportor/biler/${v.id}`} style={{ ...ui.link, ...ui.listRow }}>
            <span><strong>{v.registrationPlate}</strong> <span style={ui.hint}>{v.make}</span></span>
            <span style={chip(insp.tone)}>{insp.label}</span>
          </Link>
        ))}
      </div>

      <div style={ui.card}>
        <h2 style={ui.h2}>Kommende servicer</h2>
        {serviceDue.length === 0 && <p style={ui.hint}>Ingen biler trenger service de neste 30 dagene.</p>}
        {serviceDue.map(({ v, svc }) => (
          <Link key={v.id} to={`/transportor/biler/${v.id}`} style={{ ...ui.link, ...ui.listRow }}>
            <span><strong>{v.registrationPlate}</strong> <span style={ui.hint}>{v.make}</span></span>
            <span style={chip(svc.tone)}>{svc.label}</span>
          </Link>
        ))}
      </div>

      {away.length > 0 && (
        <div style={ui.card}>
          <h2 style={ui.h2}>Ute av drift</h2>
          {away.map(v => (
            <Link key={v.id} to={`/transportor/biler/${v.id}`} style={{ ...ui.link, ...ui.listRow }}>
              <span><strong>{v.registrationPlate}</strong> <span style={ui.hint}>{v.outOfServiceReason}</span></span>
              <span style={ui.hint}>{v.outOfServiceUntil ? `til ${v.outOfServiceUntil}` : 'ukjent slutt'}</span>
            </Link>
          ))}
        </div>
      )}

      <LeaveOrgCard />
    </>
  );
}
